import axios from '@/axiosInterceptor';

const state = () => ({
  collection: [],
  pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
});

const getters = {};

// actions

const actions = {
  async getUserInvitations(
    { commit, state },
    { page = 1, per_page = 50, refetch = false }
  ) {
    let queryParams = `user_invitations?page=${page}&per_page=${per_page}&q[s]=id desc`;
    try {
      let res = await axios.get(
        process.env.API_IDENTITY + '/api/v1/' + queryParams
      );

      if (refetch) {
        const combinedUsers = [...(state.collection || []), ...res.data];

        commit('setCollection', combinedUsers);
      } else {
        commit('setCollection', res.data);
      }
      commit('loading/loadingToggleOff', null, { root: true });

      commit('setUserInvitationPagination', {
        totalRecords: res.headers?.totalitems,
        totalPages: res.headers?.totalpages,
        currentPage: res.headers?.currentpage,
      });
      return res.data;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },

  async createUserInvitation({ commit, state, rootState }, payload) {
    const isBrokerUser =
      rootState.users.currentUser?.company?.company_type === 'broker';

    const body = {
      user_invitation: {
        email: payload.email,
        site: payload.site,
        scopes: [
          ...(isBrokerUser ? ['sourcing'] : []),
          ...(payload.scopes || []),
        ],
      },
    };

    try {
      let res = await axios.post(
        process.env.API_IDENTITY + '/api/v1/user_invitations',
        body
      );
      if ([200, 201, 204].includes(res.status)) {
        let newState = state.collection;
        newState.push(res.data);
        commit('setCollection', newState);
      }
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async destroyUserInvitation({ commit, state }, id) {
    try {
      let res = await axios.delete(
        process.env.API_IDENTITY + '/api/v1/user_invitations/' + id
      );
      if ([200, 201, 204].includes(res.status)) {
        let newState = state.collection.filter((el) => el.id !== id);
        commit('setCollection', newState);
      }
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async resendUserInvitation({ commit, state }, id) {
    try {
      let res = await axios.patch(
        process.env.API_IDENTITY + '/api/v1/user_invitations/' + id + '/resend'
      );
      if ([200, 201, 204].includes(res.status)) {
        let newState = state.collection.map((el) => {
          return el.id == id ? res.data : el;
        });
        commit('setCollection', newState);
      }
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

//mutations
const mutations = {
  setCollection(state, data) {
    state.collection = data;
  },
  setUserInvitationPagination(state, data) {
    state.pagination = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
